import { WorkoutDisplay } from '../../component/workout/workout-display'
import { useWorkout } from '../../hook/use-workouts'
import React from 'react'
import { Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { PageContainer } from 'src/component/page-container/page-container'

export const WorkoutScreen = (): React.ReactElement => {
  const { workoutId } = useParams<{ workoutId: string }>()

  const { data: workout, isLoading } = useWorkout(workoutId || '')

  if (!workoutId) {
    return <div>Workout not found</div>
  }

  if (isLoading || !workout) {
    return <div>Loading...</div>
  }

  return (
    <PageContainer>
      {/* Every sibling detail screen carries one — the training-series overview, the
          programme workout header, favourites, completed workouts. This one did not, so a
          workout opened from a Home shelf or a search result had no way back but the
          browser button. (GH-904) */}
      <Row className="mt-5 mb-4">
        <BackArrow />
      </Row>
      <WorkoutDisplay workout={workout} />
    </PageContainer>
  )
}
